import httpClient from '@/apis/base/httpclient';
import FixedAssetAPI from './_fixedAssetApi.js';

class FATransferAPI extends FixedAssetAPI {
  constructor() {
    super();
  }
  controllerName = 'FATransfers';

  /**
   * Lấy thông tin tài sản cố định ghi sổ gần nhất
   * @param Object param
   * @returns {*}
   * NVTUAN1 28.12.2022
   */
  async getLastestPostedFixedAsset(param) {
    let request = { url: this.getAPIUrl() + '/InfoFixedAssets', data: param };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy các TSCĐ được ghi tăng tính đến ngày CT hiện tại (nghiệp vụ này ngày CT = ngày HT)
   * @param Object param
   * @returns {*}
   * NVTUAN1 01.02.2023
   */
  async getFixedAssetIncrementByPostedDate(param) {
    let request = { url: this.getAPIUrl() + '/FixedAssetIncrements', data: param };

    return httpClient.postAsync(request);
  }
}

export default new FATransferAPI();
